import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { useAuth } from '#context/auth';
export const ShowIfLoggedIn: FC<{
  children: React.ReactNode;
}> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  const {
    isAuthenticated
  } = useAuth();
  if (!isAuthenticated) {
    return null;
  }
  let t1;
  if ($[0] !== children) {
    t1 = <>{children}</>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};